import React from "react"

interface HomePageContextProps {
  openContactSalesModal: () => void
}

export default React.createContext({} as HomePageContextProps)
